import { Button, Card, Divider, Group, Image, MantineTheme, Stack, Title } from "@mantine/core";
import { CircleFilledIcon, Entity, EntityDefinition, getGoogleMapsStreetViewImage, latLng, RecordGroupManager, useEntityUI, ValuesRecord } from "@mcurros2/microm";

export function VisitasPorSemanaViewInfoWindowRenderer(
    record: ValuesRecord,
    position: latLng,
    groupManager: RecordGroupManager,
    infoWindow: google.maps.InfoWindow,
    UIAPI: ReturnType<typeof useEntityUI>,
    theme: MantineTheme,
    entity: Entity<EntityDefinition>
) {
    const tienda = record[2] as string;

    const lunes = record[5] as string;
    const martes = record[6] as string;
    const miercoles = record[7] as string;
    const jueves = record[8] as string;
    const viernes = record[9] as string;
    const sabado = record[10] as string;
    const domingo = record[11] as string;

    const personal = record[12] as string;

    const image_src = getGoogleMapsStreetViewImage(position, 350, 200, 150);

    const group = groupManager.getGroupByLocation(position);

    if (group) {
        let lastTitle: string | null = null;

        return (
            <Card withBorder>
                <Stack spacing="xs" mb="xs">
                    <Image width={350} height={120} src={image_src} mx="auto" />
                    {group.records.map(
                        ({ recordValue: rec }, index) => {
                            const g_title = `${rec[2]}`;
                            const g_visita_id = rec[0] as string;
                            const g_lunes = rec[5] as string;
                            const g_martes = rec[6] as string;
                            const g_miercoles = rec[7] as string;
                            const g_jueves = rec[8] as string;
                            const g_viernes = rec[9] as string;
                            const g_sabado = rec[10] as string;
                            const g_domingo = rec[11] as string;
                            const g_personal = rec[12] as string;

                            const showTitle = g_title !== lastTitle;
                            if (showTitle) {
                                lastTitle = g_title;
                            }

                            return (<Stack key={`grp_${g_visita_id}`}>
                                {showTitle && <Title order={5}>{g_title}</Title>}
                                <Divider />
                                <Group spacing="xs">
                                    <CircleFilledIcon icon={index+1} mr="0" backColor={theme.colors.gray[6]} />
                                    {g_lunes && <>Lunes de {g_lunes} - {g_personal}</>}
                                    {g_martes && <>Martes de {g_martes} - {g_personal}</>}
                                    {g_miercoles && <>Miércoles de {g_miercoles} - {g_personal}</>}
                                    {g_jueves && <>Jueves de {g_jueves} - {g_personal}</>}
                                    {g_viernes && <>Viernes de {g_viernes} - {g_personal}</>}
                                    {g_sabado && <>Sábado de {g_sabado} - {g_personal}</>}
                                    {g_domingo && <>Domingo de {g_domingo} - {g_personal}</>}
                                    {/*<Button size="xs" ml="auto" onClick={async () => {*/}
                                    {/*    const visitas = entity as VisitasATiendas;*/}
                                    {/*    await UIAPI.handleEditClick({*/}
                                    {/*        c_solicitudruteo_id: horario.def.columns.c_solicitudruteo_id.value*/}
                                    {/*        , c_solicitudruteohorario_id: g_horario_id*/}
                                    {/*        , c_tienda_id: g_tienda_id*/}
                                    {/*    });*/}
                                    {/*}} >Editar</Button>*/}
                                </Group>
                            </Stack>)
                        }
                    )
                    }
                    <Divider />
                    <Group>
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                    </Group>
                </Stack>
            </Card>
        )
    }
    else {

        return (
            <Card withBorder padding="xs">
                <Stack spacing="0.5rem">
                    <Image width={350} height={120} src={image_src} mx="auto" />
                    <Title order={4}>{`${tienda}`}</Title>
                    {/*{exclusivo &&*/}
                    {/*    <Group spacing="xs">*/}
                    {/*        <Text weight={500} size="sm">Exclusivo: </Text>*/}
                    {/*        {exclusivo}*/}
                    {/*    </Group>*/}
                    {/*}*/}
                    {/*{compartidos &&*/}
                    {/*    <Group spacing="xs">*/}
                    {/*        <Text weight={500} size="sm">Compartidos: </Text>*/}
                    {/*        {compartidos}*/}
                    {/*    </Group>*/}
                    {/*}*/}
                    {lunes &&
                        <Group spacing="xs">
                            Lunes de {lunes} - {personal}
                        </Group>
                    }
                    {martes &&
                        <Group spacing="xs">
                            Martes de {martes} - {personal}
                        </Group>
                    }
                    {miercoles &&
                        <Group spacing="xs">
                            Miércoles de {miercoles} - {personal}
                        </Group>
                    }
                    {jueves &&
                        <Group spacing="xs">
                            Jueves de {jueves} - {personal}
                        </Group>
                    }
                    {viernes &&
                        <Group spacing="xs">
                            Viernes de {viernes} - {personal}
                        </Group>
                    }
                    {sabado &&
                        <Group spacing="xs">
                            Sábado de {sabado} - {personal}
                        </Group>
                    }
                    {domingo &&
                        <Group spacing="xs">
                            Domingo de {domingo} - {personal}
                        </Group>
                    }
                    {/*{observaciones &&*/}
                    {/*    <Group spacing="xs">*/}
                    {/*        <Text weight={500} size="sm">Observaciones: </Text>*/}
                    {/*        {observaciones}*/}
                    {/*    </Group>*/}
                    {/*}*/}
                    <Group position="right">
                        <Button size="xs" variant="light" onClick={() => {
                            infoWindow.close();
                        }}>Cerrar</Button>
                        {/*<Button size="xs" onClick={async () => {*/}
                        {/*    const visitas = entity as VisitasATiendas;*/}
                        {/*    await UIAPI.handleEditClick({*/}
                        {/*        c_solicitudruteo_id: horario.def.columns.c_solicitudruteo_id.value*/}
                        {/*        , c_solicitudruteohorario_id: horario_id*/}
                        {/*        , c_tienda_id: tienda_id*/}
                        {/*    });*/}
                        {/*}} >Editar</Button>*/}
                    </Group>
                </Stack>
            </Card>
        )
    }
}